import React, { useState } from "react";
import { motion } from "framer-motion";
import { Send, User, Phone, Mail, BookOpen, MessageSquare } from "lucide-react";
const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    course: "",
    message: "",
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const enquiryList = JSON.parse(localStorage.getItem("collegeEnquiries")) || [];
    enquiryList.push({
      ...formData,
      date: new Date().toLocaleString(),
    });
    localStorage.setItem("collegeEnquiries", JSON.stringify(enquiryList));
    alert("Your enquiry has been submitted successfully!");
    setFormData({
      name: "",
      phone: "",
      email: "",
      course: "",
      message: "",
    });
  };
  return (
    <section className="w-full bg-[#F6F8FC] py-10 md:py-12">
      <div className="w-full px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-white rounded-[28px] shadow-xl border border-gray-100 overflow-hidden"
          >
            <div className="grid lg:grid-cols-12">
              <div className="lg:col-span-5 bg-gradient-to-br from-[#071A52] via-[#0B1F5C] to-[#102B75] p-7 md:p-8 text-white relative overflow-hidden">
                <div className="absolute -top-16 -right-16 w-48 h-48 bg-[#FFD700]/20 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-20 -left-20 w-56 h-56 bg-white/10 rounded-full blur-3xl"></div>
                <div className="relative z-10">
                  <span className="inline-flex items-center gap-2 bg-[#FFD700] text-[#071A52] px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-wide mb-5">
                    Enquiry Form
                  </span>
                  <h2 className="text-2xl md:text-3xl font-black leading-tight mb-4">
                    Admission & Course Enquiry
                  </h2>
                  <p className="text-white/75 text-sm leading-relaxed mb-6">
                    Fill out the form and our college team will contact you soon
                    regarding admission, courses, and other details.
                  </p>
                  <div className="space-y-4">
                    <div className="bg-white/10 border border-white/15 rounded-2xl p-4">
                      <p className="text-[#FFD700] text-sm font-black mb-1">
                        Available Courses
                      </p>
                      <p className="text-white/80 text-sm">
                        B.A. and B.Com
                      </p>
                    </div>
                    <div className="bg-white/10 border border-white/15 rounded-2xl p-4">
                      <p className="text-[#FFD700] text-sm font-black mb-1">
                        Contact
                      </p>
                      <p className="text-white/80 text-sm">
                        +91-9451887217, +91-9450181867
                      </p>
                    </div>
                    <div className="bg-white/10 border border-white/15 rounded-2xl p-4">
                      <p className="text-[#FFD700] text-sm font-black mb-1">
                        Location
                      </p>
                      <p className="text-white/80 text-sm">
                        Arangi, Chandauli, Uttar Pradesh
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-7 p-6 md:p-8">
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-bold text-[#071A52] mb-2">
                        Full Name
                      </label>
                      <div className="relative">
                        <User
                          size={18}
                          className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
                        />
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          placeholder="Enter your name"
                          className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl pl-11 pr-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-bold text-[#071A52] mb-2">
                        Mobile Number
                      </label>
                      <div className="relative">
                        <Phone
                          size={18}
                          className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
                        />
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          placeholder="Enter mobile number"
                          className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl pl-11 pr-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-bold text-[#071A52] mb-2">
                        Email Address
                      </label>
                      <div className="relative">
                        <Mail
                          size={18}
                          className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
                        />
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter email address"
                          className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl pl-11 pr-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-bold text-[#071A52] mb-2">
                        Select Course
                      </label>
                      <div className="relative">
                        <BookOpen
                          size={18}
                          className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
                        />
                        <select
                          name="course"
                          value={formData.course}
                          onChange={handleChange}
                          required
                          className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl pl-11 pr-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all"
                        >
                          <option value="">Choose Course</option>
                          <option value="B.A.">B.A.</option>
                          <option value="B.Com">B.Com</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-[#071A52] mb-2">
                      Message
                    </label>
                    <div className="relative">
                      <MessageSquare
                        size={18}
                        className="absolute left-4 top-4 text-gray-400"
                      />
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="5"
                        placeholder="Write your enquiry..."
                        className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl pl-11 pr-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all resize-none"
                      ></textarea>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="inline-flex items-center justify-center gap-2 bg-[#071A52] text-[#FFD700] px-7 py-3 rounded-xl text-sm font-black hover:bg-[#FFD700] hover:text-[#071A52] transition-all shadow-md"
                  >
                    <Send size={17} />
                    Submit Enquiry
                  </button>
                </form>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
export default EnquiryForm;